export default __webpack_public_path__ + "static/media/HOW GREAT - vocal loop_1.c01ecac1.wav";